(function($) {
    $(document).ready(function() {
        function closeAll($accordion) {
            $accordion.find(".accordion__content").each(function() {
                $(this).css('height', '0');
            });
            $accordion.find(".accordion__content").removeClass("open");
            $accordion.find(".accordion__item").removeClass("open");
            $accordion.find(".accordion__icon").removeClass("active");
        }

        function openItem($accordionItem) {
            const $accordion = $accordionItem.closest(".accordion");
            const $content = $accordionItem.find(".accordion__content").first();

            closeAll($accordion);

            if ($content.length) {
                // Tymczasowo wyłącz transition
                $content.css('transition', 'none');
                $content.addClass("open");
                $accordionItem.addClass("open");
                $accordionItem.find(".accordion__heading .accordion__icon").first().addClass("active");
                // Wymuś przeliczenie stylów z nowym paddingiem
                void $content[0].offsetHeight;
                const scrollHeight = $content[0].scrollHeight;
                // Przywróć transition i ustaw height
                $content.css('transition', '');
                $content.css('height', scrollHeight + 'px');
            }
        }

        // Obsługa kliknięcia na nagłówki akordeonu
        $(".accordion__heading").click(function(event) {
            event.preventDefault();
    
            const clickedHeader = $(this);
            // Znajdź najbliższy accordion__item dla klikniętego nagłówka
            const accordionItem = clickedHeader.closest(".accordion__item");
            const content = accordionItem.find(".accordion__content");
            const isOpen = content.hasClass("open");
            const accordion = accordionItem.closest(".accordion");
    
            // Zamknij wszystkie sekcje tylko w ramach tego akordeonu
            closeAll(accordion);
    
            // Otwórz lub zamknij klikniętą sekcję i dodaj klasę do accordion__item
            if (!isOpen) {
                // Tymczasowo wyłącz transition
                content.css('transition', 'none');
                content.addClass("open");
                accordionItem.addClass("open");
                // Dodaj klasę aktywną do ikony
                clickedHeader.find(".accordion__icon").addClass("active");
                // Wymuś przeliczenie stylów z nowym paddingiem
                void content[0].offsetHeight;
                const scrollHeight = content[0].scrollHeight;
                // Przywróć transition i ustaw height
                content.css('transition', '');
                content.css('height', scrollHeight + 'px');
            }
        });
    
        // Otwieranie akordeonu na podstawie hash w URL
        const hash = window.location.hash;
        if (hash) {
            const targetContent = $(`${hash} .accordion__content`);
            if (targetContent.length) {
                const accordion = targetContent.closest(".accordion");
                // Zamknij wszystkie sekcje tylko w ramach docelowego akordeonu
                closeAll(accordion);

                // Otwórz docelową sekcję i dodaj klasę do accordion__item
                // Tymczasowo wyłącz transition
                targetContent.css('transition', 'none');
                targetContent.addClass("open");
                const targetItem = targetContent.closest(".accordion__item");
                targetItem.addClass("open");
                // Ustaw klasę aktywną na ikonie
                targetItem.find(".accordion__heading .accordion__icon").addClass("active");
                // Wymuś przeliczenie stylów z nowym paddingiem
                void targetContent[0].offsetHeight;
                const scrollHeight = targetContent[0].scrollHeight;
                // Przywróć transition i ustaw height
                targetContent.css('transition', '');
                targetContent.css('height', scrollHeight + 'px');
            }
        } else {
            // Domyślnie otwórz pierwszy element w każdym akordeonie (jeśli nic nie jest otwarte)
            $(".accordion").each(function() {
                const $accordion = $(this);
                if ($accordion.find('.accordion__content.open').length) {
                    return;
                }
                const $firstItem = $accordion.find('.accordion__item').first();
                if ($firstItem.length) {
                    openItem($firstItem);
                }
            });
        }

        // Przeliczanie wysokości otwartych elementów przy resize
        function recalculateAccordionHeights() {
            $(".accordion__content.open").each(function() {
                // Resetuj height, aby scrollHeight był aktualny po zmianie rozmiaru
                $(this).css('height', 'auto');
                const scrollHeight = this.scrollHeight;
                $(this).css('height', scrollHeight + 'px');
            });
        }

        let resizeTimeout;
        $(window).on('resize orientationchange', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(recalculateAccordionHeights, 100);
        });
    });
})(jQuery);

{/* <div class="accordion">
    <?php foreach($faq['faq'] as $item) : ?>
        <div class="accordion-item">
            <div class="accordion-header">
                <h3><?= $item['tytul'] ?></h3>
            </div>
            <div class="accordion-content">
                <p><?= $item['tresc'] ?></p>
            </div>
        </div>
    <?php endforeach; ?>
</div> */}